import React, { Component } from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import JsCookie from 'js-cookie'
import { FiEye } from "react-icons/fi";

class LastViewedClasses extends Component {

    constructor(props) {
        super(props);

        this.state = {
            classes: []
        }
    }

    componentDidMount() {
        this.getStudents()
    }

    getStudents() {

        fetch(process.env.REACT_APP_API_URL + "monitor/lastviewclass/employee/" + JsCookie.get("guid"),
            {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('access_token')
                }
            })
            .then((resp) => resp.json())
            .then(data => {
                console.log(data)
                this.setState({ classes: data });
            });
    }

    render() {
        return (
            <Row>
                <Col>
                <Card>
                        <Card.Body>
                            <Card.Title>Laatst bezochte klassen</Card.Title>
                            <Card.Text>
                                <Table borderless>

                                
                            {
                                    this.state.classes.map(idx => {

                                        return (

                                            <tr key={idx.id}>
                                                    <td>
                                                    <a href={"class/" + idx.class.id} className="addons-item">
                                                        {idx.class.name}</a> 
                                                    </td>
                                                    <td>
                                                        <a href={"class/" + idx.class.id} className="addons-item"><FiEye /></a>
                                                    </td>
                                            </tr>
                                        )
                                    })
                                }

                                {
                                    this.state.classes.length <= 0 ? ("Geen laatst bezochte klassen") : ""
                                }
                                </Table>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        )
    }
}

export default LastViewedClasses;